// extracted by mini-css-extract-plugin
module.exports = {"number":"AreaChart_number__1S5jY"};